import React from 'react'

const ErrorMessage = (props) => {
  return (
    <div>
        <p>{props.Message}</p>
    </div>
  )
}

export default ErrorMessage